// @flow

import React from 'react'
import { connect } from 'react-redux'
import bindAll from 'lodash/bindAll'
import imgGPlay from '../../../images/img-gplay.png'
import imgAppStore from '../../../images/img-appstore.png'
import initializers from '../../../dependencies/initializers'
import _axios from '../../../dependencies/_axios'
import UAParser from 'ua-parser-js'
import $ from 'jquery'
import { withRouter } from "react-router"
import Loader from '../../partials/Loader'

type Props = {
	interviewCode: string
};

class InviteCheckInterviewCodeBcg extends React.Component<Props> {
	constructor(props) {
		super(props)

		bindAll(this, [
			'handleCheckInterviewCode',
            'handleCopy',
		])

		this.state = {
			isMobile: false
		}

	}

    handleCopy(){
        var keyText = document.getElementById("link").select();

         document.execCommand("copy");

    }

	handleCheckInterviewCode() {
		const { interviewCode,history } = this.props

		
		const userAgent = navigator.userAgent || navigator.vendor || window.opera

		const parser = new UAParser()
		const isChrome = /chrome/i.test(parser.getBrowser().name)
		const isFirefox = /firefox/i.test(parser.getBrowser().name)
		const isSafari = /safari/i.test(parser.getBrowser().name)	
		
		if (/android/i.test(userAgent)) {
					this.setState({isMobile:true})
					// window.location = 'astronaut://astrnt.co/code/' + interviewCode

					// 		setTimeout(() => {
					// 			window.location = 'https://play.google.com/store/apps/details?id=co.astrnt.androidqa'
					// 		}, 5000)
				
		        
		      
		    } else if (/ipad|iphone|ipod/i.test(userAgent) && !window.MSStream) {
					this.setState({isMobile:true})

				
					// setTimeout(() => {
					// 	window.location = 'https://itunes.apple.com/id/app/astronaut-always-be-interviewing/id1098124247?mt=8'
					// }, 5000)
					// window.location = `astronaut://entercode?code=${interviewCode}`

						
		      
		    } else {
						_axios({
									url: `/code/${interviewCode}?debug=false`,
									timeout: 200000,				
									method: 'get',
									crossdomain:true
								})
								.then((data) => {
							
									
								
									
											this.setState({isMobile:false})
											window.location = initializers.qna_host+'/code/'+interviewCode
											
										

								})
								.catch((error) => {
								
										history.push('/notfound')
										$('.wrapper-entercode').show()
										$('#loader').hide()

									
											$("#errEnterCode").html("")
										
								})
				
				
				}


	}

	componentDidMount() {
		this.handleCheckInterviewCode()
	}

	render() {
        const{interviewCode}=this.props
		const {isMobile} = this.state

		return(
			[
			isMobile == false ? 
					<Loader/>
				:

			<div className="wrapper-maintenance center">
				<p>You cannot access this page in mobile browser.</p>
				<p>Please use a desktop computer, and access your video interview session with this link</p>
				<div className="inline-content">
					<div className="flex-container">
					<a
                        id='link'
                        onClick={this.handleCopy}
						className="m-r-10"
						target="_blank"
						rel="noopener noreferrer">
						{`${window.location.origin}/code-bcg/${interviewCode}`}
					</a>
					</div>
				</div>
			</div>

			]
			
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		interviewCode: ownProps.match.params.interviewCode
	}
}

export default withRouter(connect(mapStateToProps, null)(InviteCheckInterviewCodeBcg))
